export class ApplePayErrorUtils {
  // Check if ApplePayError is available
  public static isApplePayErrorAvailable(): boolean {
    return (
      typeof window !== "undefined" &&
      // @ts-ignore ApplePayError may or may not be defined
      typeof window.ApplePayError !== "undefined"
    );
  }

  // Create ApplePayError objects for Apple devices
  public static setApplePayErrorForAppleDevice(
    errors: ApplePayJS.ApplePayError[],
  ): ApplePayJS.ApplePayError[] {
    const applePayErrors: ApplePayJS.ApplePayError[] = [];
    errors.forEach((error) => {
      const { code, contactField, message } = error;
      applePayErrors.push(
        // @ts-ignore ApplePayError may or may not be defined
        new window.ApplePayError(code, contactField, message),
      );
    });
    return applePayErrors;
  }
}
